// @flow

import React, { useState, useRef } from "react";
import { localize } from "redux-i18n";

import {
  Button,
  SchemaForm,
  View,
  Text,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "@components";

type OwnProps = $Exact<{
  absence: Object,
  onSubmit: (data: Object) => void,
  absenceCancelReasons: [],
  onCancel: () => void,
}>;

type Props = { ...PropsFromLocalize, ...OwnProps };

function AbsenceCancelReasonsModal({
  absence,
  onSubmit,
  absenceCancelReasons,
  onCancel,
  t,
}: Props) {
  const formRef = useRef(null);

  function handleSubmit(formData: Object) {
    onSubmit(formData);
  }

  function submitForm() {
    formRef.current.submit();
  }

  const schema = {
    type: "object",
    required: ["cancelReason"],
    properties: {
      cancelReason: {
        type: "object",
        required: ["id"],
        properties: {
          id: {
            type: "integer",
            oneOf: absenceCancelReasons,
          },
        },
      },
    },
  };
  return (
    <Modal className="modal-small">
      <ModalHeader toggle={onCancel} className="d-flex justify-content-between">
        {t("CANCEL_ABSENCE")}
      </ModalHeader>
      <ModalBody>
        <View position="relative" gap={4}>
          <View
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            margin="0 0 0.5rem 0"
          >
            <Text
              className="font-size-16"
              html={t("YOU_SURE_WANT_CANCEL_ABSENCE_DETAILED_DESCRIPTION", {
                id: absence.id,
              })}
            />
          </View>
          <SchemaForm
            ref={formRef}
            schema={schema}
            uiSchema={{
              cancelReason: {
                id: {
                  "ui:options": {
                    hidelabel: true,
                  },
                },
              },
            }}
            onSubmit={handleSubmit}
            externalSubmit
          />
        </View>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-end">
        <Button color="secondary" onClick={onCancel}>
          {t("CANCEL")}
        </Button>
        <Button onClick={submitForm}>{t("SUBMIT")}</Button>
      </ModalFooter>
    </Modal>
  );
}

export default localize()(AbsenceCancelReasonsModal);
